class k {
  constructor(e = {}, o = {}) {
    console.log("Base constructor is running"), this.options = { ...e, ...o }, this.setDefaultOptions(), typeof Element < "u" && !("remove" in Element.prototype) && (Element.prototype.remove = function() {
      this.parentNode && this.parentNode.removeChild(this);
    });
  }
  setDefaultOptions() {
    this.options.onReturningUser = this.options.onReturningUser || (() => {
    }), this.options.onSetConsent = this.options.onSetConsent || (() => {
    }), this.options.cookiesToPurge = this.options.cookiesToPurge || [];
  }
}
const m = {
  cookie: {
    marketingCookieName: "marketingCookieConsent",
    analyticsCookieName: "analyticsCookieConsent",
    cookieConsentSetName: "cookieConsentSet",
    cookieValue: "1",
    cookieExpiryLengthInDays: 90
  },
  content: {},
  elements: {
    modalCCDialog: '<div class="obcc__dialog"></div>',
    modalCCMain: `
    <div role="dialog" aria-live="assertive" aria-label="cookieconsent" aria-labelledby="cookieconsent-title" aria-describedby="cookieconsent-description" aria-modal="true" class="obcc__main" aria-hidden="false">
      <h2 class="cc-heading1" id="cookieconsent-title">We respect your privacy</h2>
      <div id="cookieconsent-description">
        <p><strong>Cookies are small pieces of data that websites store on your browser when you visit them. We use  necessary cookies to ensure our website and services are able to function properly.</strong></p>
        <p>Analytics and marketing cookies are optional, they help us to improve your experience and support our marketing. Set preference by managing the cookies settings or accept both by selecting <strong>'Accept all cookies'</strong> below.</p>
      </div>
      <div class="controls">
        <button tabindex="0" class="button--secondary" id="manage-settings-trigger">Manage cookies settings</button>
        <button tabindex="0" class="button--primary accept-all-trigger" id="cookieconsent-main-acceptAllButton" >Accept all cookies</button>
      </div>
    </div>
    `,
    modalCCSettings: `
      <div role="dialog" aria-live="polite" aria-label="cookieconsent" aria-labelledby="cookieconsent-settings-title" aria-modal="true" class="obcc__settings" aria-hidden="true">
      <section class="obcc__settings__accept-all">
        <h2 class="cc-heading1" id="cookieconsent-settings-title">Manage cookies settings</h2>
        <section class="obcc__settings-block-intro-text">
          <p>Cookies are useful because they allow a website to recognise your visit and collect information about how you use that website.</p>
          <button tabindex="0" class="button--primary accept-all-trigger">Accept all cookies</button>
        </section>
      </section>
      <section class="obcc__settings-block--necessary">
        <h3 class="cc-heading2">Strictly necessary cookies</h3>
        <div class="text">
          <p>Strictly necessary cookies ensure that our website is able to function properly, and include cookies that help you log in, that provide core services and features, that help keep our website secure and that help us detect fraud or crime.</p>
        </div>
      </section>
      <section class="obcc__settings-block--optional">
        <h3 class="cc-heading2">Optional cookies</h3>
        <div class="text">
          <p>We'd also like to use cookies to provide optional features, improve our website and support our marketing. Where relevant, our trusted partners will help us make use of these optional cookies.</p>
        </div>
        <fieldset class="cookies-types-block">
          <div class="cookies-type">
            <input tabindex="0" type="checkbox" name ="cookies-type-analytics" id="cookies-type-analytics" />
            <label for="cookies-type-analytics">Analytics cookies</label>
            <div class="description">
              <p>We use digital tools to study how you interact with our website and to improve it accordingly – this is known as website analytics.</p>
              <p>These cookies help us understand how many visitors we have to the website, how many times they visit and how many times they viewed specific webpages within our site. Although these cookies allow us to gather specific information about the pages that you visit and whether you visited this website multiple times, we cannot use them to acquire details such as your name or address.</p>
            </div>
          </div>

          <div class="cookies-type">
            <input tabindex="0" type="checkbox" name="cookies-type-marketing" id="cookies-type-marketing" />
            <label for="cookies-type-marketing">Marketing cookies</label>
            <div class="description">
              <p>We and our partners use these cookies to understand what you're interested in on our website and on social media. This is so we or our partners can personalise our marketing to you.</p>
            </div>
          </div>
        </fieldset>
      </section>
      <section class="obcc__settings-block--controls">
        <div class="controls">
          <button tabindex="0" class="button--secondary" id="accept-selection-trigger">Confirm current selection</button>
          <button tabindex="0" class="button--primary accept-all-trigger">Accept all cookies</button>
        </div>
      </section>
    </div>
    `
  },
  whitelistPage: [],
  blacklistPage: []
};
/*! js-cookie v3.0.5 | MIT */
function l(t) {
  for (var e = 1; e < arguments.length; e++) {
    var o = arguments[e];
    for (var i in o)
      t[i] = o[i];
  }
  return t;
}
var S = {
  read: function(t) {
    return t[0] === '"' && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(t) {
    return encodeURIComponent(t).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function p(t, e) {
  function o(n, a, s) {
    if (!(typeof document > "u")) {
      s = l({}, e, s), typeof s.expires == "number" && (s.expires = new Date(Date.now() + s.expires * 864e5)), s.expires && (s.expires = s.expires.toUTCString()), n = encodeURIComponent(n).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var c = "";
      for (var r in s)
        s[r] && (c += "; " + r, s[r] !== !0 && (c += "=" + s[r].split(";")[0]));
      return document.cookie = n + "=" + t.write(a, n) + c;
    }
  }
  function i(n) {
    if (!(typeof document > "u" || arguments.length && !n)) {
      for (var a = document.cookie ? document.cookie.split("; ") : [], s = {}, c = 0; c < a.length; c++) {
        var r = a[c].split("="), _ = r.slice(1).join("=");
        try {
          var u = decodeURIComponent(r[0]);
          if (s[u] = t.read(_, u), n === u)
            break;
        } catch {
        }
      }
      return n ? s[n] : s;
    }
  }
  return Object.create(
    {
      set: o,
      get: i,
      remove: function(n, a) {
        o(
          n,
          "",
          l({}, a, {
            expires: -1
          })
        );
      },
      withAttributes: function(n) {
        return p(this.converter, l({}, this.attributes, n));
      },
      withConverter: function(n) {
        return p(l({}, this.converter, n), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(e) },
      converter: { value: Object.freeze(t) }
    }
  );
}
var d = p(S, { path: "/" });
const {
  marketingCookieName: y,
  analyticsCookieName: f,
  cookieConsentSetName: b,
  cookieValue: A,
  cookieExpiryLengthInDays: P
} = m.cookie, h = (t) => {
  const e = w(document.domain);
  d.set(t, A, {
    expires: P,
    domain: e
  });
}, x = () => {
  h(b);
}, E = () => ({
  AnalyticsCookieConsent: (d.get(f) == 1) + "",
  MarketingCookieConsent: (d.get(y) == 1) + ""
}), O = () => !!d.get(b), v = () => {
  h(y);
}, C = () => {
  h(f);
}, D = () => {
  v(), C();
}, I = (t, e) => (e = [
  ...e,
  /^(marketingCookieConsent|analyticsCookieConsent)/
], t.split(";").map((o) => o.replace(/=.*/, "").trim()).filter(
  (o) => e.map((i) => i.test(o)).some((i) => i)
)), L = [
  "azurewebsites.net",
  "web.core.windows.net",
  "azurefd.net"
], w = (t) => {
  if (t === "localhost" || L.some((o) => t.endsWith(o)))
    return t;
  const e = /(\w+\.)*([\w]+-?[\w]+){1}\.(com|co\.uk|credit)/;
  return e.test(t) ? "." + (t.match(e) || []).slice(-2).join(".") : t;
}, M = ["DIV", "MAIN", "FOOTER", "HEADER"], g = (t) => {
  document.body.childNodes.forEach((e) => {
    M.includes(e.nodeName) && (e.ariaHidden = t);
  });
};
class N extends k {
  constructor(e) {
    console.log("Popup constructor is running"), super(m, e);
  }
  resetHeight() {
    const e = window.innerHeight + "px", o = document.querySelector(".obcc"), i = document.querySelector(".obcc__dialog");
    !o || !i || (o.style.height = e, i.style.maxHeight = e, i.scrollTop = 0);
  }
  focusHandler(e, o = !1) {
    return (i) => {
      if (!e)
        throw "Target HTML Element should be provided";
      i.which === 9 && i.shiftKey === o && (i.preventDefault(), e.focus());
    };
  }
  createPopup() {
    document && (this.BODY = document.querySelector("body"), this.BODY_OVERFLOW = this.BODY.style.overflow, this.BODY.style.overflow = "hidden", this.POPUP = document.createElement("div"), this.POPUP.classList.add("obcc"), this.POPUP.innerHTML = this.options.elements.modalCCDialog, window.addEventListener("resize", this.resetHeight), this.DIALOG = this.POPUP.querySelector(".obcc__dialog"), this.DIALOG.innerHTML = this.options.elements.modalCCMain + this.options.elements.modalCCSettings, this.MAIN = this.POPUP.querySelector(".obcc__main"), this.SETTINGS = this.POPUP.querySelector(".obcc__settings"), this.BODY.appendChild(this.POPUP), this.resetHeight(), this.MAIN_indexed = document.querySelectorAll(".obcc__main [tabindex]"), this.SETTINGS_indexed = document.querySelectorAll(
      ".obcc__settings [tabindex]"
    ), this.mainFirst = this.MAIN_indexed[0], this.mainLast = this.MAIN_indexed[this.MAIN_indexed.length - 1], this.settingsFirst = this.SETTINGS_indexed[0], this.settingsLast = this.SETTINGS_indexed[this.SETTINGS_indexed.length - 1], this.mainFirst.focus(), this.mainFirst.addEventListener(
      "keydown",
      this.focusHandler(this.mainLast, !0)
    ), this.mainLast.addEventListener(
      "keydown",
      this.focusHandler(this.mainFirst, !1)
    ), this.settingsFirst.addEventListener(
      "keydown",
      this.focusHandler(this.settingsLast, !0)
    ), this.settingsLast.addEventListener(
      "keydown",
      this.focusHandler(this.settingsFirst, !1)
    ), document.querySelectorAll(".accept-all-trigger").forEach((e) => {
      e.addEventListener("click", (o) => {
        o.preventDefault(), console.log("write cookies"), D(), this.options.onSetConsent({
          AnalyticsCookieConsent: "true",
          MarketingCookieConsent: "true"
        }), console.log("accepted all"), this.closePopup();
      });
    }), document.querySelectorAll("#accept-selection-trigger").forEach((e) => {
      e.addEventListener("click", (o) => {
        o.preventDefault();
        const i = document.querySelectorAll("input:checked");
        this.handleCheckedSelection(i), console.log("accepted current choice"), this.closePopup();
      });
    }), document.querySelectorAll("#manage-settings-trigger").forEach((e) => {
      e.addEventListener("click", (o) => {
        o.preventDefault(), this.MAIN.setAttribute("aria-hidden", "true"), this.SETTINGS.setAttribute("aria-hidden", "false"), this.settingsFirst.focus();
      });
    }), g("true"), this.POPUP.ariaHidden = "false");
  }
  handleCheckedSelection(e) {
    let o = {
      AnalyticsCookieConsent: "false",
      MarketingCookieConsent: "false"
    };
    e.forEach((i) => {
      i.name === "cookies-type-analytics" && (C(), o.AnalyticsCookieConsent = "true"), i.name === "cookies-type-marketing" && (v(), o.MarketingCookieConsent = "true");
    }), this.options.onSetConsent(o);
  }
  closePopup() {
    x(), this.POPUP.remove(), this.BODY.style.overflow = this.BODY_OVERFLOW, g("false");
  }
}
class U extends k {
  constructor(e = {}) {
    console.log("CookieConsent constructor is running"), super(e);
  }
  createPopup() {
    this.popup = new N(this.options), O() ? this.options.onReturningUser(E()) : (I(
      document.cookie,
      this.options.cookiesToPurge
    ).forEach((e) => {
      document.cookie = `${e}=; Path=/; Max-Age=0; domain=${w(
        document.domain
      )}`;
    }), this.popup.createPopup(), document.getElementById("cookieconsent-main-acceptAllButton").focus());
  }
}
export {
  U as CookieConsent
};
